<template>
  <div>
    <h1>Ajouter une formation continue</h1>
    <form-fconttitre ref="formFct" />
    <el-divider></el-divider>
    <div style="margin-top: 8px">
      <el-button type="primary" :disabled="isSaving" @click="onSubmit"
        >Enregistrer</el-button
      >
      <el-button @click="onCancel">Annuler</el-button>
    </div>
  </div>
</template>
<script>
import FormFconttitre from "@/components/rh/ui/form/FormFconttitre";
import { strNormalize } from "@/fonctions";

export default {
  components: { "form-fconttitre": FormFconttitre },

  data() {
    return {
      isSaving: false,
    };
  },
  props: {
    routes: Object,
  },
  created() {
    // reset le form
    this.$store.commit("fctit/resetTitre", "");
  },
  computed: {
    titreCreateStatus() {
      // 1 = action en cours, 2 = succès, 3 = échec
      return this.$store.state.fctit.titreCreateStatus;
    },
  },
  methods: {
    onSubmit() {
      this.$refs.formFct.$refs.formFconttitre.validate((valid) => {
        if (valid) {
          // récupère les données de la boîte de dialogue
          const bd = this.$store.state.fctit.titre;
          // enlever les espaces avant et après dans le nom du nouveau titre
          bd.titre = bd.titre.trim();

          // vérifie si le titre est  déjà dans la bd
          const FctsInBD = this.$store.getters["fctit/titresInBD"];
          // titre en minuscule et sans espace et sans accents pour la comparaison
          const fctNormalize = strNormalize(bd.titre);

          if (FctsInBD.filter((m) => m[2] == fctNormalize).length > 0) {
            this.$alert(
              "Cette formation continue est déjà enregistrée dans la base de données !",
              "Attention",
              {
                confirmButtonText: "Fermer",
                dangerouslyUseHTMLString: true,
              }
            );
            return false;
          } else {
            //crée un nouveau enregistrement
            this.$store.dispatch("fctit/createTitre", {
              id_fcont_cat: bd.id_fcont_cat,
              titre: bd.titre,
            });
          }
        } else {
          return false;
        }
      });
    },
    onCancel() {
      // retourne à la liste des facultés
      this.$router.push(this.routes.tolist);
    },
  },
  watch: {
    titreCreateStatus() {
      // gère les messages et la navigation après soumission du formulaire
      if (this.titreCreateStatus == 2) {
        // message succès
        this.$message({
          message: "La formation continue a été ajoutée à la base de donnée",
          type: "success",
        });

        // va au formulaire d'édition du la thèse
        this.$router.push(this.routes.toedit);
      } else if (this.titreCreateStatus == 3) {
        this.isSaving = false;
        // message échec
        this.$message.error({ message: "Echec de l'enregistrement !" });
      } else if (this.titreCreateStatus == 1) {
        this.isSaving = true;
      } else if (this.titreCreateStatus == 0) {
        this.isSaving = false;
      }
    },
  },
};
</script>
